import { Guid } from 'guid-typescript';

import {
  StakeholderComplaint,
  StakeholderAreaOfInterest,
  StakeholderClub,
  StakeholderContact,
  StakeholderInteraction,
  StakeholderLanguage,
  StakeholderMapping,
  StakeholderOrganization,
  StakeholderPostalAddress,
  StakeholderProperty,
  StakeholderSocialMedia,
  StakeholderTask,
} from '@cradua/domain';
import { EpimsBaseEntityDto } from '@cradua/data';
import { TitleDto } from './title.dto';
import { PoliticalPartyDto } from './politicalparty.dto';

export class StakeholderDto {
  public id: string;
  public StakeholderId: string;
  public Surname: string;
  public Firstname: string;
  public Middlename: string;
  public TitleId: string;
  public StakeholderDesc: string;
  public LevelOfInfluence: number;
  public LevelOfInterest: number;
  public LevelOfImpact: number;
  public RelationshipRating: number;
  public DOB: Date;
  public DOBShort: string;
  public CreatedById: string;
  public SubscriberId: string;
  public SiteId: string;
  public ObjPartnershipDesc: string;
  public ObjPolicyDevDesc: string;
  public ObjPRDesc: string;
  public ObjSomeoneToBlameDesc: string;
  public DecisionInfluence: string;
  public Gender: string;
  public OrganizationHistory: string;
  public AgeBracket: string;

  public ModifiedById: string;
  public Fullname: string;
  public Title: TitleDto;
  public PoliticalParty: PoliticalPartyDto;
  public stakeholderComplaints: Array<StakeholderComplaint>;
  public stakeholderAreaOfInterests: Array<StakeholderAreaOfInterest>;
  public stakeholderClubs: Array<StakeholderClub>;
  public stakeholderContacts: Array<StakeholderContact>;
  public stakeholderInteractions: Array<StakeholderInteraction>;
  public stakeholderLanguages: Array<StakeholderLanguage>;
  public stakeholderMappings: Array<StakeholderMapping>;
  public stakeholderOrganizations: Array<StakeholderOrganization>;
  public stakeholderPostalAddresses: Array<StakeholderPostalAddress>;
  public stakeholderPropertys: Array<StakeholderProperty>;
  public stakeholderSocialMedias: Array<StakeholderSocialMedia>;
  public stakeholderTasks: Array<StakeholderTask>;
}

class Stakeholder {
  public StakeholderId: string;
  public Surname: string;
  public Firstname: string;
  public Middlename: string;
  public TitleId: string;
  public StakeholderDesc: string;
  public LevelOfInfluence: number;
  public LevelOfInterest: number;
  public LevelOfImpact: number;
  public RelationshipRating: number;
  public DOB: Date;
  public DOBShort: string;
  public CreatedById: string;
  public SubscriberId: string;
  public SiteId: string;
  public ObjPartnershipDesc: string;
  public ObjPolicyDevDesc: string;
  public ObjPRDesc: string;
  public ObjSomeoneToBlameDesc: string;
  public CreatedAt: Date;
  public ModifiedAt: Date;
  public ModifiedById: string;
  public DecisionInfluence: string;

  public StakeholderComplaints: Array<StakeholderComplaint>;
  public StakeholderAreaOfInterests: Array<StakeholderAreaOfInterest>;
  public StakeholderClubs: Array<StakeholderClub>;
  public StakeholderContacts: Array<StakeholderContact>;
  public StakeholderInteractions: Array<StakeholderInteraction>;
  public StakeholderLanguages: Array<StakeholderLanguage>;
  public StakeholderMappings: Array<StakeholderMapping>;
  public StakeholderOrganizations: Array<StakeholderOrganization>;
  public StakeholderPostalAddresses: Array<StakeholderPostalAddress>;
  public StakeholderPropertys: Array<StakeholderProperty>;
  public StakeholderSocialMedias: Array<StakeholderSocialMedia>;
  public StakeholderTasks: Array<StakeholderTask>;
}
